const ShareViaEmail_mutate = `
    mutation shareViaEmail(
      $email: String!,
      $note: String!,
      $url: String,
      $contentType: String!,
      $contentTitle: String!) {
      shareViaEmail(
        email: $email,
        note: $note,
        url: $url,
        contentType: $contentType,
        contentTitle: $contentTitle) {
          response
      }
    }
`;


module.exports = {
  SHARE_VIA_EMAIL_MUTATION : ShareViaEmail_mutate,
}
